import React, { ReactNode } from 'react';
import NavBar from '../navbar/NavBar';
import Footer from '../footer/Footer';

interface MainLayoutProps {
  children: ReactNode;
  isFooterContentWhite?: boolean;
  isFooterBackgroundWhite?: boolean;
  id?: string;
  isTransparent?: boolean;
}

/**
 * MainLayout component that provides a consistent layout with NavBar and Footer
 * for pages across the application.
 */
const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  id,
  isFooterBackgroundWhite,
  isFooterContentWhite,
  isTransparent,
}) => {
  return (
    <>
      <NavBar isTransparent={isTransparent} />
      <main id={id}>{children}</main>
      <Footer
        isFooterContentWhite={isFooterContentWhite}
        isFooterBackgroundWhite={isFooterBackgroundWhite}
      />
    </>
  );
};

export default MainLayout;
